import { atom, useAtom } from "jotai"
import { atomFamily } from "jotai/utils"
import { useCallback, useDeferredValue } from "react"

/*
 * About this:
 * Make eg. <input value={useTextFilter[0]} onChange={useTextFilter[1]} />
 *
 * Create another component where you use the value as deferred value as you need or
 *
 * simply use useFilteredData with the data you want to filter by the text in textFilter
 */

// TextFilter is scoped per section. Fina.Statements is now using project scope too. Will see if that's good or not
export type TextFilterId = "project" | "market" | "metric"

const textFilterAtoms = atomFamily((id: TextFilterId) => atom({ [id]: "" }))

export const useTextFilter = (id: TextFilterId) => {
  const [{ [id]: textFilter }, setState] = useAtom(textFilterAtoms(id))

  const setFilter = useCallback(
    (value: string) => {
      setState({ [id]: value })
    },
    [id, setState]
  )

  return [textFilter, setFilter] as const
}

export const useDeferredTextFilter = (id: TextFilterId) => {
  const [textFilter] = useTextFilter(id)
  return useDeferredValue(textFilter)
}
